module.exports = __webpack_public_path__ + "img/20191118160410360截图20191118155018255.f7fae52c.jpg";